import { atom } from "jotai";
import { DataSchema } from "common";

export const suggestionsAtom = atom<DataSchema.Suggest["items"]>([]);
